import { useSelector } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';

/**
 * Returns a `boolean` indicating the state of unsuccessful login.
 */
export const useHasFailedToFetchCustomerData = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => {
    const { matches, history } = state;

    const wasFetchingCustomerData = history?.matches('fetching.customer') === true;
    const hasLoggedOut = matches('session.loggedOut');

    return wasFetchingCustomerData && hasLoggedOut;
  });
};
